import React, { useState } from 'react';
import { TouchableOpacity, Text, View, StyleSheet, ActivityIndicator } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores } from '../../../../styles/variablesCss';
import { useCart } from '../../../../context/CartContext';

/**
 * Componente para controlar las cantidades de items en el carrito
 * @param {Object} props - Propiedades del componente
 * @param {string|number} props.plu - ID del producto
 * @param {number} props.cantidad - Cantidad a agregar o quitar (positivo para agregar, negativo para quitar)
 * @param {Function} props.onSuccess - Función a ejecutar después de la operación exitosa
 * @param {Object} props.style - Estilos adicionales
 * @param {React.ReactNode} props.children - Contenido del botón
 */
const CartItemControl = ({ plu, cantidad, style, onSuccess, children }) => {
  const [loading, setLoading] = useState(false);
  // Obtener la función agregarAlCarrito del contexto
  const { agregarAlCarrito } = useCart();

  const actualizarCantidad = async () => {
    try {
      setLoading(true);
      
      // Usar la función centralizada para modificar el carrito
      // cantidad puede ser positiva (agregar) o negativa (quitar)
      const result = await agregarAlCarrito(plu, cantidad);
      
      if (result.success && onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Error al actualizar cantidad:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <TouchableOpacity
      style={[styles.button, style]}
      onPress={actualizarCantidad}
      disabled={loading}
    >
      {loading ? (
        <ActivityIndicator size="small" color={colores.blanco} />
      ) : (
        children
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    justifyContent: 'center',
    alignItems: 'center',
  }
});

export default CartItemControl;
